import { NewsInterface } from '@shared/environments/translations';

export interface EnvironmentInterface {
  production?: boolean;
  apiHost?: string;
  loadDataPeriod?: number;
  telegramBotId?: string;
  defaultLocale?: string;
  global?: boolean;
  newRoleModel?: boolean;
  cliVisible?: boolean;
  authIgnore?: {
    enabled?: boolean;
    login?: string;
    keycloakId?: string;
    name?: string;
    email?: string;
  };
  keycloak?: {
    enabled?: boolean;
    url?: string;
    clientId?: string;
    realm: string;
    credentials?: {
      secret?: string;
    };
    standardFlow?: boolean;
  };
  amplitude?: {
    enabled?: boolean;
    apiKey?: string;
    logLevel?: number;
  };
  googleAnalytics?: {
    enabled?: boolean;
    gaTrackingId?: string;
  };
  sentry?: {
    enabled?: boolean;
    dsn?: string;
    environment?: string;
  };
  news?: NewsInterface[];
  components?: {
    termsUpdateHtml?: string;
  };
  vendor?: {
    name?: string;
    legalName?: string;
    osName?: string;
    dnsName?: string;
    dnsExample?: string;
    supportUrl?: string;
    docsUrl?: string;
    forumUrl?: string;
  };
}

export enum EnvironmentLocalesEnum {
  EN = 'en',
  RU = 'ru',
}
